/* global JSX */
import { Box, Grid } from "@mui/material";
import * as React from "react";
import { IRecordEditItemFamiliarization, RecordEditItemFamiliarization } from "source/models/record/recordEditItemFamiliarization";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { ToolButtonDropdown } from "ui/Scripts/source/components/framework/Button/ToolButtonDropdown";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { Base } from "ui/Scripts/source/framework/base";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { RecordEmployeeType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow, SaveTaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { IListFilterItem } from "../../../models/common/listFilterItem";
import { infiniteListPageSize } from "../../../models/common/webConsts";
import { IRecordEditItemFurtherEducation, RecordEditItemFurtherEducationSave } from "../../../models/record/recordEditItemFurtherEducation";
import { IRecordEditItemTransferredProperty, RecordEditItemTransferredProperty, RecordEditItemTransferredPropertySave } from "../../../models/record/recordEditItemTransferredProperty";
import { IRecordListItem } from "../../../models/record/recordListItem";
import * as recordService from "../../../models/services/recordService";
import { ISessionState } from "../../../models/session/sessionState";
import { ActionContainer } from "../../framework/ActionContainer";
import { AddButton } from "../../framework/Button/AddButton";
import { GridRow } from "../../framework/Grid/GridRow";
import { IListUsingComponentState, List } from "../../framework/List/List";
import { ListActionButtons } from "../../framework/List/ListActionButtons";
import { ListCardField } from "../../framework/List/ListCardField";
import { MainListContainer } from "source/components/framework/List/MainListContainer";
import { ListDetailsButton } from "../../framework/List/ListDetailsButton";
import { ListLinkValue } from "../../framework/List/ListLinkValue";
import { ListSearchContainer } from "../../framework/List/ListSearchContainer";
import { ListSearchFilter } from "../../framework/List/ListSearchFilter";
import { ListStateIconCertificate } from "../../framework/List/ListStateIconCertificate";
import { ListToggleButtons } from "../../framework/List/ListToggleButtons";
import { PageTitle } from "../../framework/Page/PageTitle";
import { RecordArchiveExpiredFamiliarizationsDialog } from "../RecordArchiveExpiredFamiliarizationsDialog";
import { RecordArchiveExpiredFurtherEducationsDialog } from "../RecordArchiveExpiredFurtherEducationsDialog";
import { RecordEditViewMode } from "../RecordEdit";
import { RecordEditDialog } from "../RecordEditDialog";
import { RecordEditFurtherEducationList } from "../RecordEdit/RecordEditFurtherEducationList";
import { RecordEditNewRecordDialog } from "../RecordNewRecordDialog/RecordNewRecordDialog";
import { RecordEditSheetDataRowDialog } from "../RecordEdit/RecordEditSheetDataRowDialog";
import { RecordUserFamiliarizationDialog } from "../RecordUserFamiliarizationDialog";
import { RecordUserFurtherEducationDialog } from "../RecordUserFurtherEducationDialog";
import { RecordUserTransferredPropertyDialog } from "../RecordUserTransferredPropertyDialog";
import { SelectRecordDialog } from "../SelectRecordDialog";
import { SelectQualificationDialog } from "../SelectQualificationDialog";
import { AppMoreIcon } from "source/components/framework/Icon/AppMoreIcon";
import { IRecordCompanyFurtherEducationGroups } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordCompanyFurtherEducationGroups";
import { IRecordCompanyRecordFamiliarizationListItems } from "source/models/record/recordCompanyRecordFamiliarizationListItems";
import { IRecordFamiliarizationListItem } from "ui/Scripts/source/models/recordFamiliarization/recordFamiliarizationListItem";
import { RecordListFirstColumn } from "./RecordListFirstColumn";
import { ListStateIconFamiliarization } from "source/components/framework/List/ListStateIconFamiliarization";
import { RecordEditItemUserFamiliarizationSave } from "ui/Scripts/source/models/recordUserFamiliarization/recordEditItemUserFamiliarization";
import { RecordEditSheetDataRowList } from "../RecordEdit/RecordEditSheetDataRowList";

/* eslint-disable no-unused-vars */
const enum SelectRecordMode {
    FurtherEducation = "0",
    SalaryRow = "1",
    TransferredProperty = "2",
    Qualifification = "3",
    Familiarization = "4"
}
/* eslint-enable no-unused-vars */

export interface IRecordListProp {
    sessionState: ISessionState;
    savedFilter: IListFilterItem;
    companyId: string;
    disableGlobalLoading?: boolean;
    listFilterIsSet: boolean;
    units: IIdTitleNode[];
    jobTitles: IIdTitle[];
    companyFamiliarizations?: IRecordCompanyRecordFamiliarizationListItems[];
    companyFurtherEducationGroups?: IRecordCompanyFurtherEducationGroups[];
    selectedEmployeeTypeIds?: string[];
    selectedJobTitleIds?: string[];
    selectedUnitIds?: string[];
    selectedActivityFilterId?: string;
    dataId?: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    startDateStr?: string;
    endDateStr?: string;
    sheetTaskType: ITaskEditTypeItem;
    titleSuffix?: JSX.Element;
    reportTabs: React.ReactNode;
    onRefreshSessionState: () => void;
    onSetSortData: (sortColumn: string, sortOrderIsAsc: boolean) => void;
    onEmploymentSaved: () => void;
    onOpenFiltersDialog: () => void;
}

interface IRecordListState extends IListUsingComponentState<IRecordListItem> {
    // List
    intialized: boolean;
    isLoading: boolean;
    pageSize: number;
    page: number;
    filter: string;
    employeeTypes: number[];
    jobTitles: string[];
    unitIds: string[];
    activityState: number;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    listModeIsLine: boolean;
    checkedIds: string[];

    // New Dialog
    showNewRecordDialog: boolean;
    newRecordDialogUnitId: string;
    newRecordDialogUnitCode: string;
    newRecordDialogEmployeeType: RecordEmployeeType;

    // Dialog
    editDialogDefaultMenuItem: RecordEditViewMode;

    // Additional functions
    showSelectRecordDialog: boolean;
    selectRecordDialogMode: SelectRecordMode;
    additionalFunctionRecordIds: string[];

    // Additional functions: AddFurtherEducationToMultipleUserRecords
    showRecordUserFurtherEducationDialog: boolean;
    recordUserFurtherEducationDialogItem: IRecordEditItemFurtherEducation;
    furtherEducations: IIdTitleNode[];
    furtherEducationGroups: IRecordFurtherEducationGroupNode[];

    // Additional functions: AddSalaryRowToMultipleUserRecords
    transferredPropertyTypes: string[];
    showRecordEditSheetDataRowDialog: boolean;
    recordEditSheetDataRowDialogItem: ITaskDataRow;

    // Additional functions: AddTransferredPropertyToMultipleUserRecords
    showRecordUserTransferredPropertyDialog: boolean;
    recordUserTransferredPropertyDialogItem: IRecordEditItemTransferredProperty;

    // Additional functions: AddQualificationToMultipleUserRecords
    showSelectQualificationDialog: boolean;

    // Additional functions: AddFamiliarizationToMultipleUserRecords
    familiarizations: IRecordFamiliarizationListItem[];
    showRecordUserFamiliarizationDialog: boolean;
    recordUserFamiliarizationDialogItem: IRecordEditItemFamiliarization;
    familiarizationTrainers: string[];

    // Additional functions: ArchiveExpiredFamiliarizations
    showArchiveExpiredFamiliarizationsDialog: boolean;

    // Additional functions: ArchiveExpiredFurtherEducations
    showArchiveExpiredFurtherEducationsDialog: boolean;
}

export class RecordList extends React.Component<IRecordListProp, IRecordListState> {
    constructor(props: IRecordListProp) {
        super(props);
        this.state = {
            intialized: false,
            isLoading: false,
            page: 1,
            hasMore: true,
            filter: "",
            employeeTypes: props.selectedEmployeeTypeIds ? props.selectedEmployeeTypeIds.filter(i => !Base.isNullOrEmpty(i)).map(i => i.toInteger()) : [],
            jobTitles: props.selectedJobTitleIds ? props.selectedJobTitleIds.filter(i => !!i) : [],
            unitIds: props.selectedUnitIds ? props.selectedUnitIds.filter(i => i !== Base.emptyGuid) : [],
            activityState: props.selectedActivityFilterId ? parseInt(props.selectedActivityFilterId, 10) : 0,
            pageSize: infiniteListPageSize,
            sortColumn: props.sortColumn,
            sortOrderIsAsc: props.sortOrderIsAsc,
            listModeIsLine: true,
            items: [],
            selectedId: null,
            checkedIds: [],
            // Details
            detailsItem: null,
            // New Dialog
            showNewRecordDialog: false,
            newRecordDialogUnitId: "",
            newRecordDialogUnitCode: "",
            newRecordDialogEmployeeType: RecordEmployeeType.Employee,
            // Dialog
            showEditDialog: false,
            editDialogId: "",
            editDialogHasPrevious: false,
            editDialogHasNext: false,
            editDialogDefaultMenuItem: RecordEditViewMode.General,
            // Additional functions
            showSelectRecordDialog: false,
            selectRecordDialogMode: SelectRecordMode.FurtherEducation,
            additionalFunctionRecordIds: [],
            // Additional functions: AddFurtherEducationToMultipleUserRecords
            showRecordUserFurtherEducationDialog: false,
            recordUserFurtherEducationDialogItem: null,
            furtherEducations: [],
            furtherEducationGroups: [],
            // Additional functions: AddSalaryRowToMultipleUserRecords
            showRecordEditSheetDataRowDialog: false,
            recordEditSheetDataRowDialogItem: null,
            // Additional functions: AddTransferredPropertyToMultipleUserRecords
            transferredPropertyTypes: [],
            showRecordUserTransferredPropertyDialog: false,
            recordUserTransferredPropertyDialogItem: null,
            // Additional functions: AddFamiliarizationToMultipleUserRecords
            familiarizations: [],
            showRecordUserFamiliarizationDialog: false,
            recordUserFamiliarizationDialogItem: null,
            familiarizationTrainers: [],
            // Additional functions: AddQualificationToMultipleUserRecords
            showSelectQualificationDialog: false,
            // Additional functions: ArchiveExpiredFamiliarizations
            showArchiveExpiredFamiliarizationsDialog: false,
            // Additional functions: ArchiveExpiredFurtherEducations
            showArchiveExpiredFurtherEducationsDialog: false
        };
    }

    searchItems = async (pageSize: number, page: number, filter: string, employeeTypes: number[], jobTitles: string[], unitIds: string[], activityState: number, sortColumn: string, sortOrderIsAsc: boolean,
        resetItems: boolean, refreshList: boolean, moveNext: boolean = false, setDialogData: boolean = true) => {
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => recordService.getRecordListItems(this.props.companyId, !refreshList ? pageSize : (page * pageSize), !refreshList ? page : 1, filter, employeeTypes, jobTitles, unitIds, activityState, sortColumn, sortOrderIsAsc),
            false, this.props.disableGlobalLoading, () => this.setState({ isLoading: false }));
        if (!result) return;
        result.initializeQualifications();
        const items = List.getListItems(this.state.items, this.state.selectedId, this.state.checkedIds, result.items, resetItems, refreshList);
        let selectedId = items.selectedId;
        let index = items.items.findIndex(i => i.id === selectedId);
        let detailsItem = index > -1 ? items.items[index] : null;
        if (moveNext && detailsItem && index < items.items.length - 1) {
            index = index + 1;
            detailsItem = items.items[index];
            selectedId = items.items[index].id;
        }
        this.setState({
            intialized: true,
            page: !refreshList ? result.page : page,
            hasMore: result.hasMore,
            filter,
            employeeTypes,
            jobTitles,
            unitIds,
            activityState,
            sortColumn,
            sortOrderIsAsc,
            items: items.items,
            selectedId,
            checkedIds: items.checkedIds,
            detailsItem,
            editDialogDefaultMenuItem: setDialogData ? RecordEditViewMode.General : this.state.editDialogDefaultMenuItem,
            editDialogId: setDialogData ? (moveNext && detailsItem ? detailsItem.id : "") : this.state.editDialogId,
            editDialogHasPrevious: setDialogData ? index > 0 : this.state.editDialogHasPrevious,
            editDialogHasNext: setDialogData ? (index < items.items.length - 1 || result.hasMore) : this.state.editDialogHasNext,
        });
        this.props.onSetSortData(sortColumn, sortOrderIsAsc);
    };

    refreshList = async (setDialogData: boolean = true) => {
        const state = this.state;
        await this.searchItems(state.pageSize, state.page, state.filter, state.employeeTypes, state.jobTitles, state.unitIds, state.activityState, state.sortColumn, state.sortOrderIsAsc, false, true, false, setDialogData);
    };

    componentDidMount(): void {
        const state = this.state;
        this.searchItems(state.pageSize, state.page, state.filter, state.employeeTypes, state.jobTitles, state.unitIds, state.activityState, state.sortColumn, state.sortOrderIsAsc, true, false);
    }

    componentDidUpdate(prevProps: IRecordListProp, prevState: IRecordListState) {
        const props = this.props;
        const state = this.state;
        const prevDataId = prevProps.dataId ? prevProps.dataId : "";
        const dataId = props.dataId ? props.dataId : "";
        const prevCompanyId = prevProps.companyId ? prevProps.companyId : "";
        const companyId = props.companyId ? props.companyId : "";
        const prevEmployeeTypes = prevProps.selectedEmployeeTypeIds ? prevProps.selectedEmployeeTypeIds.filter(i => !Base.isNullOrEmpty(i)).map(i => i.toInteger()) : [];
        const employeeTypes = props.selectedEmployeeTypeIds ? props.selectedEmployeeTypeIds.filter(i => !Base.isNullOrEmpty(i)).map(i => i.toInteger()) : [];
        const prevJobTitles = prevProps.selectedJobTitleIds ? prevProps.selectedJobTitleIds.filter(i => !!i) : [];
        const jobTitles = props.selectedJobTitleIds ? props.selectedJobTitleIds.filter(i => !!i) : [];
        const prevUnitIds = prevProps.selectedUnitIds ? prevProps.selectedUnitIds.filter(i => i !== Base.emptyGuid) : [];
        const unitIds = props.selectedUnitIds ? props.selectedUnitIds.filter(i => i !== Base.emptyGuid) : [];
        const prevActivityState = prevProps.selectedActivityFilterId ? parseInt(prevProps.selectedActivityFilterId, 10) : 0;
        const activityState = props.selectedActivityFilterId ? parseInt(props.selectedActivityFilterId, 10) : 0;
        const prevSortColumn = prevProps.sortColumn;
        const sortColumn = props.sortColumn;
        const prevSortOrderIsAsc = prevProps.sortOrderIsAsc;
        const sortOrderIsAsc = props.sortOrderIsAsc;
        if (dataId === prevDataId && companyId === prevCompanyId &&
            Base.equalArrays(prevEmployeeTypes, employeeTypes) &&
            Base.equalStrArrays(prevJobTitles, jobTitles) &&
            Base.equalStrArrays(prevUnitIds, unitIds) &&
            prevActivityState === activityState &&
            prevSortColumn === sortColumn && prevSortOrderIsAsc === sortOrderIsAsc) return;
        this.searchItems(state.pageSize, state.page, state.filter, employeeTypes, jobTitles, unitIds, activityState, sortColumn, sortOrderIsAsc, true, false);
    }

    changeFilter = (filter: string) => {
        const state = this.state;
        this.searchItems(state.pageSize, 1, filter, state.employeeTypes, state.jobTitles, state.unitIds, state.activityState, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        const state = this.state;
        this.searchItems(state.pageSize, !nextPage ? 1 : state.page + 1, state.filter, state.employeeTypes, state.jobTitles, state.unitIds, state.activityState, sortColumn, sortOrderIsAsc, !nextPage, false);
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.setState({
            selectedId,
            checkedIds,
            detailsItem: this.state.items.find(i => i.id === selectedId)
        });
    };
    
    handleListModeChange = (listModeIsLine: boolean) => {
        this.setState({
            listModeIsLine,
        });
    };

    handleListModeToggle = (_event: React.MouseEvent<HTMLElement>, listModeIsLine: boolean) => {
        this.setState({
            listModeIsLine,
        });
    };

    // #region Edit dialog
    handleOpenLine = (id: string) => {
        this.setState(List.getShowEditDialogStateChange(this.state, id));
    };

    handleUserDialogOk = () => {
        this.refreshList(false);
    };

    handleUserDialogCancel = (listRefreshNeeded: boolean) => {
        this.setState({
            showEditDialog: false
        });
        if (!listRefreshNeeded) return;
        this.refreshList(false);
    };

    handleUserDialogNewSaved = (newRecordId: string) => {
        this.setState({
            showEditDialog: true,
            selectedId: newRecordId,
            editDialogId: newRecordId,
            editDialogHasPrevious: false,
            editDialogHasNext: false,
            editDialogDefaultMenuItem: RecordEditViewMode.Education
        });
        this.refreshList(false);
    };

    setEditDialogItemByIndex = (index: number) => {
        const state = this.state;
        this.setState(List.getEditDialogItemByIndexStateChange(this.state, index, () => this.searchItems(state.pageSize, state.page + 1, state.filter, state.employeeTypes, state.jobTitles, state.unitIds, state.activityState, state.sortColumn, state.sortOrderIsAsc, false, false, true)));
    };
    // #endregion Edit dialog

    // #region Add dialog
    handleAdd = () => {
        const props = this.props;
        const state = this.state;
        const units = props.units.filter(i => i.id !== Base.emptyGuid && i.id !== "00000000-0000-0000-0000-000000000001");
        let unit = state.unitIds.length > 0 ? IdTitleNode.getById(units, state.unitIds[0]) : null;
        if (!unit && !units[0]?.hasChildren()) {
            unit = units[0];
        }
        this.setState({
            showNewRecordDialog: true,
            newRecordDialogUnitId: unit ? unit.id : "",
            newRecordDialogUnitCode: unit ? unit.title : "",
            newRecordDialogEmployeeType: state.employeeTypes.length > 0 ? state.employeeTypes[0] : RecordEmployeeType.Employee,
        });
    };

    handleEditNewRecordDialogOk = (recordId: string) => {
        this.setState({
            showNewRecordDialog: false
        });
        this.refreshList();
    };

    handleEditNewRecordDialogCancel = () => {
        this.setState({
            showNewRecordDialog: false
        });
    };
    // #endregion Add dialog

    handlePrint = async () => {
        const state = this.state;
        if (!state.selectedId) return;
        const fileName = await AppUtils.callService(() => recordService.getRecordPrint(state.selectedId, this.props.companyId));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, fileName));
    };

    // #region Additional functions: SelectRecord
    handleSelectRecordDialogOk = async (companyId: string, records: IRecordListItem[]) => {
        const props = this.props;
        if (!records || records.length < 1) return;
        const state = this.state;
        const showRecordUserFurtherEducationDialog = state.selectRecordDialogMode === SelectRecordMode.FurtherEducation;
        const showRecordEditSheetDataRowDialog = state.selectRecordDialogMode === SelectRecordMode.SalaryRow;
        const showRecordUserTransferredPropertyDialog = state.selectRecordDialogMode === SelectRecordMode.TransferredProperty;
        const showSelectQualificationDialog = state.selectRecordDialogMode === SelectRecordMode.Qualifification;
        const showRecordUserFamiliarizationDialog = state.selectRecordDialogMode === SelectRecordMode.Familiarization;
        let transferredPropertyTypes: string[] = [];
        let familiarizationTrainers: string[] = [];
        if (showRecordUserTransferredPropertyDialog) {
            transferredPropertyTypes = await AppUtils.callService(() => recordService.getTransferredPropertyTypes(props.companyId));
        } else if (showRecordUserFamiliarizationDialog) {
            familiarizationTrainers = await AppUtils.callService(() => recordService.getFamiliarizationTrainers(companyId));
        }
        const furtherEducationGroups = showSelectQualificationDialog || showRecordUserFurtherEducationDialog
            ? props.companyFurtherEducationGroups.find(i => i.companyId === companyId)?.furtherEducationGroups ?? []
            : [];
        const familiarizations = showRecordUserFamiliarizationDialog
            ? props.companyFamiliarizations.find(i => i.companyId === companyId)?.familiarizations ?? []
            : [];
        this.setState({
            showSelectRecordDialog: false,
            additionalFunctionRecordIds: records.map(i => i.id),
            transferredPropertyTypes,
            familiarizationTrainers,
            showRecordUserFurtherEducationDialog,
            showRecordEditSheetDataRowDialog,
            showRecordUserTransferredPropertyDialog,
            showSelectQualificationDialog,
            showRecordUserFamiliarizationDialog,
            furtherEducationGroups,
            furtherEducations: showSelectQualificationDialog
                ? RecordFurtherEducationGroupNode.getFurtherEducationsForQualification(furtherEducationGroups)
                : null,
            familiarizations,
            recordUserFurtherEducationDialogItem: showRecordUserFurtherEducationDialog
                ? RecordEditFurtherEducationList.createNewRecordEditItemFurtherEducation(furtherEducationGroups)
                : null,
            recordEditSheetDataRowDialogItem: showRecordEditSheetDataRowDialog
                ? RecordEditSheetDataRowList.createNewTaskDataRow(props.sheetTaskType)
                : null,
            recordUserTransferredPropertyDialogItem: showRecordUserTransferredPropertyDialog
                ? RecordEditItemTransferredProperty.createNewRecordEditItemTransferredProperty()
                : null,
            recordUserFamiliarizationDialogItem: showRecordUserFamiliarizationDialog
                ? RecordEditItemFamiliarization.createNewRecordEditItemFamiliarization(familiarizations)
                : null
        });
    };

    handleSelectRecordDialogCancel = () => {
        this.setState({
            showSelectRecordDialog: false
        });
    };
    // #endregion Additional functions: SelectRecord

    // #region Additional functions: AddFurtherEducationToMultipleUserRecords
    handleAddFurtherEducationToMultipleUserRecords = () => {
        this.setState({
            showSelectRecordDialog: true,
            selectRecordDialogMode: SelectRecordMode.FurtherEducation
        });
    };

    getAddFurtherEducationToMultipleUserRecordsSaveData = (props: IRecordListProp, recordIds: string[], recordFurtherEducation: RecordEditItemFurtherEducationSave): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("ids", recordIds);
        result.append("companyId", props.companyId);
        result.append("furtherEducation", recordFurtherEducation);
        return result;
    };

    handleRecordUserFurtherEducationDialogSave = async (saveItem: RecordEditItemFurtherEducationSave): Promise<ApiSuccess> => {
        const state = this.state;
        const saveData = this.getAddFurtherEducationToMultipleUserRecordsSaveData(this.props, state.additionalFunctionRecordIds, saveItem);
        // Call server
        const result = await AppUtils.callService(() => recordService.addFurtherEducationToRecords(saveData.obj));
        if (!result) return null;
        return result;
    };

    handleRecordUserFurtherEducationDialogOk = (recordFurtherEducation: IRecordEditItemFurtherEducation, closeDialog: boolean) => {
        if (!recordFurtherEducation) return;
        this.setState({
            showRecordUserFurtherEducationDialog: false
        });
        this.refreshList(false);
    };

    handleRecordUserFurtherEducationDialogCancel = () => {
        this.setState({
            showRecordUserFurtherEducationDialog: false
        });
    };
    // #endregion Additional functions: AddFurtherEducationToMultipleUserRecords

    // #region Additional functions: AddSalaryRowToMultipleUserRecords
    handleAddSalaryRowToMultipleUserRecords = () => {
        if (!this.props.sheetTaskType) return;
        this.setState({
            showSelectRecordDialog: true,
            selectRecordDialogMode: SelectRecordMode.SalaryRow
        });
    };

    getAddSalaryRowToMultipleUserRecordsSaveData = (props: IRecordListProp, recordIds: string[], sheetDataRow: ITaskDataRow): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("ids", recordIds);
        result.append("companyId", props.companyId);
        result.append("sheetDataRow", SaveTaskDataRow.createSaveTaskDataRow(props.sheetTaskType.formCols, sheetDataRow, null));
        return result;
    };

    handleRecordEditSheetDataRowDialogSave = async (sheetDataRow: ITaskDataRow): Promise<SaveSuccess> => {
        const state = this.state;
        const saveData = this.getAddSalaryRowToMultipleUserRecordsSaveData(this.props, state.additionalFunctionRecordIds, sheetDataRow);
        // Call server
        const result = await AppUtils.callService(() => recordService.addSheetDataRowToRecords(saveData.obj));
        if (!result) return null;
        return result;
    };

    handleRecordEditSheetDataRowDialogDialogOk = (salaryRow: ITaskDataRow, rowId: string, closeDialog: boolean) => {
        if (!salaryRow) return;
        this.setState({
            showRecordEditSheetDataRowDialog: false
        });
        this.refreshList(false);
    };

    handleRecordEditSheetDataRowDialogCancel = (_refreshList: boolean) => {
        this.setState({
            showRecordEditSheetDataRowDialog: false
        });
    };
    // #endregion Additional functions: AddSalaryRowToMultipleUserRecords

    // #region Additional functions: AddTransferredPropertyToMultipleUserRecords
    handleAddTransferredPropertyToMultipleUserRecords = () => {
        this.setState({
            showSelectRecordDialog: true,
            selectRecordDialogMode: SelectRecordMode.TransferredProperty
        });
    };

    getAddTransferredPropertyToMultipleUserRecordsSaveData = (props: IRecordListProp, recordIds: string[], transferredProperty: IRecordEditItemTransferredProperty): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("ids", recordIds);
        result.append("companyId", props.companyId);
        result.append("transferredProperty", new RecordEditItemTransferredPropertySave(transferredProperty));
        return result;
    };

    handleRecordUserTransferredPropertyDialogSave = async (transferredProperty: IRecordEditItemTransferredProperty): Promise<SaveSuccess> => {
        const state = this.state;
        const saveData = this.getAddTransferredPropertyToMultipleUserRecordsSaveData(this.props, state.additionalFunctionRecordIds, transferredProperty);
        // Call server
        const result = await AppUtils.callService(() => recordService.addTransferredPropertyToToRecords(saveData.obj));
        if (!result) return null;
        return result;
    };

    handleRecordUserTransferredPropertyDialogOk = (transferredProperty: IRecordEditItemTransferredProperty, closeDialog: boolean) => {
        if (!transferredProperty) return;
        this.setState({
            showRecordUserTransferredPropertyDialog: false
        });
        this.refreshList(false);
    };

    handleRecordUserTransferredPropertyDialogCancel = () => {
        this.setState({
            showRecordUserTransferredPropertyDialog: false
        });
    };
    // #endregion Additional functions: AddTransferredPropertyToMultipleUserRecords
    
    // #region Additional functions: AddQualificationToMultipleUserRecords
    handleAddQualificationToMultipleUserRecords = () => {
        this.setState({
            showSelectRecordDialog: true,
            selectRecordDialogMode: SelectRecordMode.Qualifification
        });
    };

    getAddQualificationToMultipleUserRecordsSaveData = (props: IRecordListProp, recordIds: string[], furtherEducationId: string, furtherEducationGroupId: string): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("ids", recordIds);
        result.append("companyId", props.companyId);
        result.append("furtherEducationId", furtherEducationId);
        result.append("furtherEducationGroupId", furtherEducationGroupId);
        return result;
    };

    handleRecordUserQualificationDialogSave = async (furtherEducationOrGroupId: string): Promise<SaveSuccess> => {
        if (!furtherEducationOrGroupId) return;
        const state = this.state;
        const item = RecordFurtherEducationGroupNode.getItemById(state.furtherEducationGroups, furtherEducationOrGroupId);
        if (!item) return;
        const isGroup = RecordFurtherEducationGroupNode.isGroup(item);
        const saveData = this.getAddQualificationToMultipleUserRecordsSaveData(this.props, state.additionalFunctionRecordIds, !isGroup ? item.id : null, isGroup ? item.id : null);
        // Call server
        const result = await AppUtils.callService(() => recordService.addQualificationToToRecords(saveData.obj));
        if (!result) return null;
        return result;
    };

    onSelectQualificationDialogOk = async (selectedIds: string[]) => {
        if (!selectedIds || selectedIds.length < 1) return;
        await this.handleRecordUserQualificationDialogSave(selectedIds[0]);
        this.setState({
            showSelectQualificationDialog: false
        });
        this.refreshList(false);
    };

    onSelectQualificationDialogCancel = () => {
        this.setState({
            showSelectQualificationDialog: false
        });
    };
    // #endregion Additional functions: AddTransferredPropertyToMultipleUserRecords

    // #region Additional functions: AddFamiliarizationToMultipleUserRecords
    handleAddFamiliarizationToMultipleUserRecords = () => {
        this.setState({
            showSelectRecordDialog: true,
            selectRecordDialogMode: SelectRecordMode.Familiarization
        });
    };

    getAddFamiliarizationToMultipleUserRecordsSaveData = (props: IRecordListProp, recordIds: string[], recordEditItemUserFamiliarizationSave: RecordEditItemUserFamiliarizationSave): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("ids", recordIds);
        result.append("companyId", props.companyId);
        result.append("familiarization", recordEditItemUserFamiliarizationSave);
        return result;
    };

    handleRecordUserFamiliarizationDialogSave = async (recordEditItemUserFamiliarizationSave: RecordEditItemUserFamiliarizationSave): Promise<SaveSuccess> => {
        const state = this.state;
        const saveData = this.getAddFamiliarizationToMultipleUserRecordsSaveData(this.props, state.additionalFunctionRecordIds, recordEditItemUserFamiliarizationSave);
        // Call server
        const result = await AppUtils.callService(() => recordService.addFamiliarizationToToRecords(saveData.obj));
        if (!result) return null;
        return result;
    };

    handleRecordUserFamiliarizationDialogOk = (recordFamiliarization: IRecordEditItemFamiliarization, _closeDialog: boolean) => {
        if (!recordFamiliarization) return;
        this.refreshList(false);
    };

    handleRecordUserFamiliarizationDialogCancel = () => {
        this.setState({
            showRecordUserFamiliarizationDialog: false
        });
    };
    // #endregion Additional functions: AddTransferredPropertyToMultipleUserRecords
    
    // #region Additional functions: ArchiveExpiredFamiliarizations
    handleArchiveExpiredFamiliarizations = () => {
        this.setState({
            showArchiveExpiredFamiliarizationsDialog: true
        });
    };

    handleArchiveExpiredFamiliarizationsDialogOk = () => {
        this.setState({
            showArchiveExpiredFamiliarizationsDialog: false
        });
        this.refreshList(false);
    };

    handleArchiveExpiredFamiliarizationsDialogCancel = () => {
        this.setState({
            showArchiveExpiredFamiliarizationsDialog: false
        });
    };
    // #endregion Additional functions: ArchiveExpiredFurtherEducations

    // #region Additional functions: ArchiveExpiredFurtherEducations
    handleArchiveExpiredFurtherEducations = () => {
        this.setState({
            showArchiveExpiredFurtherEducationsDialog: true
        });
    };

    handleArchiveExpiredFurtherEducationsDialogOk = () => {
        this.setState({
            showArchiveExpiredFurtherEducationsDialog: false
        });
        this.refreshList(false);
    };

    handleArchiveExpiredFurtherEducationsDialogCancel = () => {
        this.setState({
            showArchiveExpiredFurtherEducationsDialog: false
        });
    };
    // #endregion Additional functions: ArchiveExpiredFurtherEducations

    getDetailsFamiliarizations = (): React.ReactNode => {
        const state = this.state;
        if (!state.detailsItem) return null;
        const familiarizations = state.detailsItem.familiarizations.filter(i => !i.archived).map(i => i.name + " (" + (i.validityEndDate ? Base.utcTimeToDateStr(i.validityEndDate) : "-") + ")");
        return (
            <GridRow>
                <Grid item sm={12}>
                    <ListCardField title={Translations.Familiarizations} value={Base.getStringWithSeparators(familiarizations, ", ")} />
                </Grid>
            </GridRow>
        );
    };

    getDetailsFurtherEducations = (): React.ReactNode => {
        const state = this.state;
        if (!state.detailsItem) return null;
        const furtherEducations = state.detailsItem.furtherEducations.filter(i => !i.archived).map(i => i.furtherEducationCode + " (" + (i.validityEndDate ? Base.utcTimeToDateStr(i.validityEndDate) : "-") + ")");
        return (
            <GridRow>
                <Grid item sm={12}>
                    <ListCardField title={Translations.FurtherEducations} value={Base.getStringWithSeparators(furtherEducations, ", ")} />
                </Grid>
            </GridRow>
        );
    };

    getDetailsQualifications = (): React.ReactNode => {
        const state = this.state;
        if (!state.detailsItem || !state.detailsItem.hasQualifications()) return null;
        const qualifications = state.detailsItem.getQualificationsForUi();
        return (
            <GridRow>
                <Grid item sm={12}>
                    <ListCardField title={Translations.Qualifications} value={Base.getStringWithSeparators(qualifications, ", ")} />
                </Grid>
            </GridRow>
        );
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <>
                <PageTitle title={Translations.Resources + (props.savedFilter ? " - " + props.savedFilter.title : (props.listFilterIsSet || state.filter ? " - " + Translations.Filtered : ""))}>
                    <AddButton variant="contained" onClick={this.handleAdd}>
                        {Translations.AddRecordUser}
                    </AddButton>
                </PageTitle>
                <MainListContainer>
                    <ActionContainer
                        margin="1rem .5rem 1rem 1rem"
                        leftItems={
                            props.reportTabs
                        }
                        rightItems={
                            <>
                                <ListActionButtons
                                    filterIsSet={props.listFilterIsSet}
                                    printDisabled={!state.selectedId}
                                    onFilter={props.onOpenFiltersDialog}
                                    onPrint={this.handlePrint}
                                />
                                <ListToggleButtons value={state.listModeIsLine} onChange={this.handleListModeToggle} />
                                <ToolButtonDropdown
                                    variant="icon"
                                    actions={[
                                        { title: Translations.ArchiveExpiredFamiliarizations, onClick: this.handleArchiveExpiredFamiliarizations },
                                        { title: Translations.ArchiveExpiredFurtherEducations, onClick: this.handleArchiveExpiredFurtherEducations },
                                        { title: Translations.AddFurtherEducationToMultipleUserRecords, onClick: this.handleAddFurtherEducationToMultipleUserRecords },
                                        { title: Translations.AddTransferredPropertyToMultipleUserRecords, onClick: this.handleAddTransferredPropertyToMultipleUserRecords },
                                        { title: Translations.AddFamiliarizationToMultipleUserRecords, onClick: this.handleAddFamiliarizationToMultipleUserRecords },
                                        { title: Translations.AddQualificationToMultipleUserRecords, onClick: this.handleAddQualificationToMultipleUserRecords },
                                        { title: Translations.AddSalaryRowToMultipleUserRecords, onClick: props.sheetTaskType ? this.handleAddSalaryRowToMultipleUserRecords : null },
                                    ]}
                                    icon={<AppMoreIcon />}
                                    tooltip={Translations.AdditionalFunctions}
                                    menuRight={true}
                                />
                            </>
                        }
                    />
                    <ListSearchContainer>
                        <ListSearchFilter
                            searchFilter={state.filter}
                            onSearchClick={this.changeFilter} />
                    </ListSearchContainer>
                    <List
                        intialized={state.intialized}
                        isLoading={state.isLoading}
                        hasMore={state.hasMore}
                        globalLoadingInUse={!props.disableGlobalLoading}
                        height="calc(100vh - 296px)" //Main List
                        header={state.listModeIsLine
                            ? {
                                columns: [
                                    { size: 2, column: "unit", content: Translations.Unit },
                                    { size: 3, column: "lastName", content: Translations.LastName },
                                    { size: 3, column: "firstName", content: Translations.FirstName },
                                    { size: 2, column: "birthDate", content: Translations.BirthDate },
                                    { size: 2, column: "userCode", content: Translations.UserName }
                                ]
                            }
                            : null}
                        lines={state.listModeIsLine
                            ? state.items.map((item) => {
                                return {
                                    columns: [
                                        {
                                            size: 2,
                                            content: <RecordListFirstColumn item={item} title={item.unitCode} />
                                        },
                                        {
                                            size: 3,
                                            content:
                                            <Box display="flex" justifyContent="space-between" flexGrow={2}>
                                                <Box display="flex">
                                                    <AvatarImage
                                                        id={item.userCode}
                                                        name={item.getName()}
                                                        image={item.picture}
                                                        tooltip={item.getName()}
                                                        marginRight=".5rem"
                                                    />
                                                    <ListLinkValue onClick={() => this.handleOpenLine(item.id)}>{item.lastName}</ListLinkValue>
                                                </Box>
                                                <Box>
                                                    {item.hasUnApprovedFamiliarizations() &&
                                                        <ListStateIconFamiliarization approved={false} />
                                                    }
                                                    {item.hasQualifications() &&
                                                        <ListStateIconCertificate valid={item.allQualificationsOk()} />
                                                    }
                                                </Box>
                                            </Box>
                                        },
                                        { size: 3, content: item.firstName },
                                        { size: 2, content: Base.timeToDateStr(item.birthDate) },
                                        { size: 2, content: item.userCode }
                                    ],
                                    id: item.id,
                                    classes: item.archived ? "disabled" : ""
                                };
                            })
                            : null
                        }
                        cards={!state.listModeIsLine
                            ? state.items.map((item) => {
                                return {
                                    //classes: (item.archived ? " disabled" : ""),
                                    sm: 4,
                                    rows: [
                                        {
                                            cols: [
                                                {
                                                    size: 6,
                                                    title: Translations.Name,
                                                    value:
                                                    <Box display="flex" alignItems="center">
                                                        <AvatarImage
                                                            id={item.userCode}
                                                            name={item.getName()}
                                                            image={item.picture}
                                                            tooltip={item.getName()}
                                                            marginRight=".5rem"
                                                        />
                                                        <ListLinkValue onClick={() => this.handleOpenLine(item.id)}>{item.getName()}</ListLinkValue>
                                                    </Box>
                                                },
                                                { size: 6, title: Translations.EmployeeType, value: item.employeeTypeStr }
                                            ]
                                        },
                                        {
                                            cols: [
                                                { size: 6, title: Translations.Phone, value: item.phone },
                                                { size: 6, title: Translations.EmailAddress, value: item.email }
                                            ]
                                        },
                                        {
                                            cols: [
                                                { size: 6, title: Translations.BirthDate, value: Base.timeToDateStr(item.birthDate) },
                                                { size: 6, disabled: item.userDisabled, title: Translations.UserName, value: item.userCode }
                                            ]
                                        }],
                                    id: item.id
                                };
                            })
                            : null
                        }
                        lineDetails={state.detailsItem
                            ? <Box position="relative">
                                <GridRow>
                                    <Grid item sm={12} md={4}>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField title={Translations.Name} value={state.detailsItem.getName()} />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField title={Translations.EmailAddress} value={state.detailsItem.email} />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField title={Translations.Phone} value={state.detailsItem.phone} />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField title={Translations.EmployeeType} value={state.detailsItem.employeeTypeStr} />
                                            </Grid>
                                        </GridRow>
                                    </Grid>
                                    <Grid item sm={12} md={4}>
                                        {this.getDetailsFamiliarizations()}
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField title={Translations.BasicEducation} value={state.detailsItem.basicEducationName} />
                                            </Grid>
                                        </GridRow>
                                        {this.getDetailsFurtherEducations()}
                                        {this.getDetailsQualifications()}
                                    </Grid>
                                    {!!state.detailsItem.userCode &&
                                    <Grid item sm={12} md={4}>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField title={Translations.UserName} value={state.detailsItem.userCode} />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField title={Translations.UserGroups} value={Base.getStringWithSeparators(state.detailsItem.userGroups.map(i => i.name + (i.companyName ? ` (${i.companyName})` : "")), ", ")} />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField title={Translations.ValidityDate} value={Base.timeToDateStr(state.detailsItem.userEndDate)} />
                                            </Grid>
                                        </GridRow>
                                    </Grid>
                                    }
                                    {!state.detailsItem.userCode &&
                                    <Grid item sm={12} md={4}>
                                        <GridRow>
                                            <Grid item sm={12}>
                                                <ListCardField value={Translations.UserAccountNotConnected} />
                                            </Grid>
                                        </GridRow>
                                    </Grid>
                                    }
                                </GridRow>
                                <ListDetailsButton
                                    onClick={() => this.handleOpenLine(state.selectedId)}
                                />
                            </Box>
                            : null}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        selectedId={state.selectedId}
                        checkedIds={state.checkedIds}
                        onSetSelectedIds={this.handleSetSelectedIds}
                        onSearchLines={this.handleSearchLines}
                        onOpenLine={this.handleOpenLine}
                    />
                </MainListContainer>
                {state.showNewRecordDialog &&
                    <RecordEditNewRecordDialog
                        companyId={props.companyId}
                        unitId={state.newRecordDialogUnitId}
                        unitCode={state.newRecordDialogUnitCode}
                        employeeType={state.newRecordDialogEmployeeType}
                        onOk={this.handleEditNewRecordDialogOk}
                        onCancel={this.handleEditNewRecordDialogCancel}
                    />
                }
                {(state.showEditDialog && !!state.editDialogId) &&
                    <RecordEditDialog
                        sessionState={props.sessionState}
                        companyId={props.companyId}
                        recordId={state.editDialogId}
                        defaultMenuItem={state.editDialogDefaultMenuItem}
                        hasPrevious={state.editDialogHasPrevious}
                        hasNext={state.editDialogHasNext}
                        onOk={this.handleUserDialogOk}
                        onCancel={this.handleUserDialogCancel}
                        onNewSaved={this.handleUserDialogNewSaved}
                        onRefreshList={() => this.refreshList(false)}
                        onPrevious={() => List.moveToPrevious(state, this.setEditDialogItemByIndex)}
                        onNext={() => List.moveToNext(state, this.setEditDialogItemByIndex)}
                        onRefreshSessionState={props.onRefreshSessionState}
                        onEmploymentSaved={props.onEmploymentSaved}
                    />
                }
                {state.showSelectRecordDialog &&
                    <SelectRecordDialog
                        companyId={props.companyId}
                        multiSelect={true}
                        requireSheetType={state.selectRecordDialogMode === SelectRecordMode.SalaryRow}
                        title={state.selectRecordDialogMode === SelectRecordMode.FurtherEducation
                            ? Translations.AddFurtherEducationToMultipleUserRecords
                            : (state.selectRecordDialogMode === SelectRecordMode.SalaryRow
                                ? Translations.AddSalaryRowToMultipleUserRecords
                                : (state.selectRecordDialogMode === SelectRecordMode.Familiarization
                                    ? Translations.AddFamiliarizationToMultipleUserRecords
                                    : (state.selectRecordDialogMode === SelectRecordMode.Qualifification
                                        ? Translations.AddQualificationToMultipleUserRecords
                                        : Translations.AddTransferredPropertyToMultipleUserRecords)))}
                        units={props.units}
                        jobTitles={props.jobTitles}
                        canSelectOnlyOneCompanyRecords={state.selectRecordDialogMode !== SelectRecordMode.TransferredProperty && state.selectRecordDialogMode !== SelectRecordMode.SalaryRow}
                        onOk={this.handleSelectRecordDialogOk}
                        onCancel={this.handleSelectRecordDialogCancel}
                    />
                }
                {state.showRecordUserFurtherEducationDialog &&
                    <RecordUserFurtherEducationDialog
                        companyId={props.companyId}
                        recordId={Base.emptyGuid}
                        userCode=""
                        recordQualifications={[]}
                        furtherEducationGroups={state.furtherEducationGroups}
                        item={state.recordUserFurtherEducationDialogItem}
                        attachments={[]}
                        hasPrevious={null}
                        hasNext={null}
                        onCustomSave={this.handleRecordUserFurtherEducationDialogSave}
                        onSaved={this.handleRecordUserFurtherEducationDialogOk}
                        onClose={this.handleRecordUserFurtherEducationDialogCancel}
                        onPrevious={null}
                        onNext={null}
                        onAttachmentsAdded={null}
                        onAttachmentsRemoved={null}
                    />
                }
                {state.showRecordEditSheetDataRowDialog &&
                    <RecordEditSheetDataRowDialog
                        taskType={props.sheetTaskType}
                        item={state.recordEditSheetDataRowDialogItem}
                        hasPrevious={false}
                        hasNext={false}
                        saveToDb={this.handleRecordEditSheetDataRowDialogSave}
                        onSaved={this.handleRecordEditSheetDataRowDialogDialogOk}
                        onClose={this.handleRecordEditSheetDataRowDialogCancel}
                        onPrevious={null}
                        onNext={null}
                    />
                }
                {state.showRecordUserTransferredPropertyDialog &&
                    <RecordUserTransferredPropertyDialog
                        companyId={props.companyId}
                        recordId={Base.emptyGuid}
                        userCode=""
                        transferredPropertyTypes={state.transferredPropertyTypes}
                        item={state.recordUserTransferredPropertyDialogItem}
                        hasPrevious={null}
                        hasNext={null}
                        attachments={[]}
                        onCustomSave={this.handleRecordUserTransferredPropertyDialogSave}
                        onSaved={this.handleRecordUserTransferredPropertyDialogOk}
                        onClose={this.handleRecordUserTransferredPropertyDialogCancel}
                        onPrevious={null}
                        onNext={null}
                        onAttachmentsAdded={null}
                        onAttachmentsRemoved={null}
                    />
                }
                {state.showRecordUserFamiliarizationDialog &&
                    <RecordUserFamiliarizationDialog
                        sessionState={props.sessionState}
                        companyId={props.companyId}
                        recordId={Base.emptyGuid}
                        unitId={null}
                        userId={Base.emptyGuid}
                        userCode=""
                        familiarizations={state.familiarizations}
                        familiarizationTrainers={state.familiarizationTrainers}
                        item={state.recordUserFamiliarizationDialogItem}
                        attachments={[]}
                        hasPrevious={null}
                        hasNext={null}
                        onCustomSave={this.handleRecordUserFamiliarizationDialogSave}
                        onSaved={this.handleRecordUserFamiliarizationDialogOk}
                        onClose={this.handleRecordUserFamiliarizationDialogCancel}
                        onPrevious={null}
                        onNext={null}
                        onAttachmentsAdded={null}
                        onAttachmentsRemoved={null}
                    />
                }
                {state.showArchiveExpiredFamiliarizationsDialog &&
                    <RecordArchiveExpiredFamiliarizationsDialog
                        companyId={props.companyId}
                        onOk={this.handleArchiveExpiredFamiliarizationsDialogOk}
                        onCancel={this.handleArchiveExpiredFamiliarizationsDialogCancel}
                    />
                }
                {state.showArchiveExpiredFurtherEducationsDialog &&
                    <RecordArchiveExpiredFurtherEducationsDialog
                        companyId={props.companyId}
                        onOk={this.handleArchiveExpiredFurtherEducationsDialogOk}
                        onCancel={this.handleArchiveExpiredFurtherEducationsDialogCancel}
                    />
                }
                {state.showSelectQualificationDialog &&
                    <SelectQualificationDialog
                        nodes={state.furtherEducations}
                        selectedIds={[]}
                        onOk={this.onSelectQualificationDialogOk}
                        onCancel={this.onSelectQualificationDialogCancel}
                    />
                }
            </>
        );
    }
}